import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Message = styled(TextLayoutComponent)`
  color: #8A94AA;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  width: 100%;
`;
